import type { TFunction } from "i18next";
import U2000SaveCancelDialog from "../../../../../u2000Core/components/dialog/U2000SaveCancelDialog";
import type { U2103Role } from "../../../../U2103Service";
import type { U2103UserRoleHandler } from "./U2103UserRoleHandlers";

// Typage des props du composant
interface U2103UserRoleDlgProps {
  u2103UserRoleHandler: U2103UserRoleHandler;
  t: TFunction;
  NS: string;
}

// Composant pour le dialogue d'édition des actions d'une unité logique
function U2103UserRoleEditDlg({ u2103UserRoleHandler, t, NS }: U2103UserRoleDlgProps) {
  // renmder
  return (
    <U2000SaveCancelDialog
      width="w-[700px]"
      isOpen={u2103UserRoleHandler.isDialogOpen}
      onClose={u2103UserRoleHandler.onDlgClose}
      title={t("lblLogicalUnitAction", { ns: NS })}
      // isValid={u2103UserRoleHandler.formStateHandlers.isValid()}
    >
      <div className="flex flex-col gap-y-4">
        {u2103UserRoleHandler.roles &&
          u2103UserRoleHandler.roles.map((role: U2103Role, index) => (
            <div key={index} className="mb-1 flex items-center gap-x-2">
              <div
                className={`h-6 w-6 cursor-pointer rounded-sm border-2 transition-colors duration-300 ${role.idChecked ? "border-blue-500 bg-blue-100" : "border-gray-300 bg-white"}`}
                onClick={() => u2103UserRoleHandler.onCheckRole(role)}
              >
                {role.idChecked && (
                  <svg className="m-auto h-5 w-5 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <p className="inline-block text-gray-800">
                {role.roleCode} - {role.roleDescription}
              </p>
            </div>
          ))}
      </div>
    </U2000SaveCancelDialog>
  );
}

export default U2103UserRoleEditDlg;
